import {createContext, useContext} from 'react'

import {FieldsConfiguration} from '../fields/types'

export type CommonFieldsConfiguration = Omit<FieldsConfiguration, 'dateTime'>

export const CommonConfigurationContext = createContext<CommonFieldsConfiguration | undefined>(undefined)

export const useCommonConfigurationContext = (): CommonFieldsConfiguration => {
  const context = useContext(CommonConfigurationContext)

  if (!context) {
    throw new Error('useCommonConfigurationContext must be used within a CommonConfigurationContextProvider')
  }

  return context
}

export const useCommonFieldConfigurationContext = <T extends keyof CommonFieldsConfiguration>(
  key: T
): CommonFieldsConfiguration[T] => useCommonConfigurationContext()[key]